export default [
  {
    header: 'Полоски',
  },
  {
    title: 'Список полосок',
    route: 'strips-list',
    icon: 'GridIcon',
    tagVariant: 'light-info',
  },
  {
    title: 'Создать полоску',
    route: 'strip-builder-create',
    icon: 'PlusSquareIcon',
    tagVariant: 'light-info',
  },
  {
    title: 'Импорт архива',
    route: 'strip-import-archive',
    icon: 'UploadIcon',
    tagVariant: 'light-info',
  },
  {
    title: 'Импорт SIQ',
    route: 'strip-import-siq',
    icon: 'PackageIcon',
    tagVariant: 'light-info',
  },
]
